import { v4 as uuidv4 } from "uuid";
import { Integrator } from "../integrator";
import { Store } from "./Store";
import { Webhook } from "./Webhook";

export class WebhookSubscription {
	Guid: string = uuidv4();
	LicenseKey: string;
	venueKey: number;
	WebhookGuid: string;
	WebhookUrl: string;
	Active: boolean;
	Created: Date;
	Updated: Date;
	Successes: number;
	Failures: number;
	LastFailure: Date;
	LastSuccess: Date;

	Webhook: Webhook;

	Store: Store;

	integrator: Integrator;

	public constructor(init?: Partial<WebhookSubscription>) {
		Object.assign(this, init);
	}
}
